import React from "react";
import ReservationsSegmentCheckInRoomSelect from "./ReservationsSegmentCheckInRoomSelect";
import ReservationSegmentCheckInCustomersSelect from "./ReservationSegmentCheckInCustomersSelect";

export default class ReservationSegmentCheckInRoomDetails extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-body container">
          <h5
            className="panel-heading-text"
            style={{ borderBottom: "1px solid #DFDFDF", paddingBottom: 20 }}
          >
            {I18n.t("room_details")}{" "}
          </h5>
          <div className="row room-guest-details">
            {this.renderRoom()}
            {this.renderGuestInRoom()}
          </div>
        </div>
      </div>
    );
  }

  renderRoom() {
    return (
      <div className="col-sm">
        <div className="form-group">
          <label>{I18n.t("room")}</label>
          {this.props.room ? (
            <ReservationsSegmentCheckInRoomSelect
              room={this.props.room}
              room_type={this.props.reservation_segment.room_type}
              reservation_segment_id={this.props.reservation_segment.id}
              dateFormat={this.props.date_format}
              onChange={this.props.onChangeRoom}
            />
          ) : (
            <div className="form-control has-errors">{`${I18n.t(
              "no_clean_and_vacant"
            )} ${this.props.reservation_segment.room_type.name}`}</div>
          )}
        </div>
      </div>
    );
  }

  renderGuestInRoom() {
    return (
      <div className="col-sm">
        <div className="form-group">
          <label>{I18n.t("customers_staying_in_room")}</label>
          <ReservationSegmentCheckInCustomersSelect
            customers={this.props.customers}
            onChange={this.props.onChangeGuestInRoom}
          />
          <a
            href="/admin/customers/new"
            data-nested="true"
            className="btn btn-link btn-xs modal-iframe"
          >
            {I18n.t("new_customer")}
          </a>
        </div>
      </div>
    );
  }
}
